import React from 'react';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';

export const DebriefSection = ({ onEdit, onView, title }) => (
  <section>
    <Typography variant="h6">{title}</Typography>
    <FPActionButton onClick={onView} text={strings.shared.ui.view} variant="outlined" />
    <FPActionButton onClick={onEdit} text={strings.shared.ui.edit} variant="contained" />
  </section>
);
